<!-- room type detail-->
<template>
  <transition name="fade">
    <div class="position-relative z-index-1045">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-bottom d-table w-100 nav-bottom" style="top:40px">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-10 position-relative" :class="{'col-lg-4':data.room_type.image == ''}">
                <div class="rounded-4 bg-white" style="height: 90vh;">
                  <div class="">
                    <div class="row no-gutters">
                      <div class="col-7 col-lg-8" v-if="data.room_type.image != ''">
                        <div class="w-100">
                          <flickity ref="flickity" class="room-detail text-center" :options="flickityOptionsRoom">
                            <div class="carousel-cell w-100" v-for="data_image in data.room_type.image">
                              <div class="w-100 position-relative bg-dark-transparent" style="height: 90vh !important;">
                                <img :src="data_image.image_url" class="position-relative z-index-1045" style="object-fit:contain !important; height:100%;width:100%;">
                                <div class="position-absolute w-100 z-index-1042 bg-blur-overlay" :style="{ backgroundImage: `url('${data_image.image_url}')` }"></div>
                              </div>
                            </div>
                          </flickity>
                        </div>
                      </div>
                      <div class="col-5 col-lg-4 position-relative" :class="{'col-lg-12':data.room_type.image == ''}">
                        <div class="w-100" style="overflow-y: scroll;height: 90vh;">
                          <img src="../../../../assets/img/icon/cancel.png"
                            class="d-inline-block p-2 rounded-3 bg-back mt-3 mx-4 cursor-pointer position-absolute"
                            width="33" style="z-index: 1038;right: 0" @click="onBack('detailRoom', false)">
                          <div class="py-4">
                            <div class="container px-4">
                              <p class="mb-3 body-1-4 text-22 w-90">{{data.name}}</p>

                              <!-- HIGHTLIGHT -->
                              <ul class="pl-3 mb-4">
                                <li><p class="mb-0 body-2-2">{{data.minimum_deposit_value > 0 ? 'Prepayment is required' : 'No Prepayment required'}}</p></li>
                                <li><p class="mb-0 body-2-2">{{data.cancellation_policy.title}}</p></li>
                                <li><p class="mb-0 body-2-2" :class="data.rate.is_included_breakfast?'text-success':'text-danger'">{{data.rate.is_included_breakfast?'Breakfast Included':'No meal included'}}</p></li>
                              </ul>

                              <!-- DESCRIPTION -->
                              <div v-if="$isNotEmpty(data.description_room_rate) || $isNotEmpty(data.description_promotion)">
                                <p class="mb-1 body-3-3 text-16 font-bold">{{$t('general.description')}}</p>
                                <p v-if="$isNotEmpty(data.description_room_rate)" class="mb-0 body-3-3 text-14 font-regular" v-html="$convertNewlinesToBr(data.description_room_rate)"></p>
                                <span v-if="$isNotEmpty(data.description_room_rate) && $isNotEmpty(data.description_promotion)" class="my-2 w-100 d-block"></span>
                                <p v-if="$isNotEmpty(data.description_promotion)" class="mb-0 body-2-1 text-14 font-regular" v-html="$convertNewlinesToBr(data.description_promotion)"></p>
                              </div>


                              <!-- CANCELLATION POLICY -->
                              <template v-if="data.cancellation_policy != null">
                                <div class="d-block mb-3 mt-4">
                                  <p class="mb-1 body-3-3 text-16 font-bold">{{data.cancellation_policy.title}}</p>
                                  <p class="mb-0 body-3-3 text-14 font-regular html-desc" v-html="data.cancellation_policy.description"></p>
                                </div>
                              </template>

                              <!-- TERMS & CONDITIONS -->
                              <template v-if="$isNotEmpty(data.term_and_condition_room_rate) || $isNotEmpty(data.term_and_condition_promotion)">
                                <div class="d-block mb-3 mt-4">
                                  <div class="mb-3" v-if="$isNotEmpty(data.term_and_condition_room_rate)">
                                    <p class="mb-1 body-3-3 text-16 font-bold">{{data.term_and_condition_room_rate.title}}</p>
                                    <p class="mb-0 body-3-3 text-14 font-regular html-desc" v-html="data.term_and_condition_room_rate.description"></p>
                                  </div>
                                  <div v-if="$isNotEmpty(data.term_and_condition_promotion)">
                                    <p class="mb-1 body-3-3 text-16 font-bold">{{data.term_and_condition_promotion.title}}</p>
                                    <p class="mb-0 body-3-3 text-14 font-regular html-desc" v-html="data.term_and_condition_promotion.description"></p>
                                  </div>
                                </div>
                              </template>

                              <!-- RATE INCLUSIONS -->
                              <template v-if="data.rate.inclusion.length > 0">
                                <p class="pt-3 mb-1 body-3-3 text-16 font-bold">{{$t('hotel.room-type.include-in-rate')}}</p>
                                <div class="height-auto">
                                  <ul  class="pl-3">
                                    <li class="mb-2" v-for="(inclusion, index) in data.rate.inclusion">
                                      <span class="body-2-1 d-block">{{inclusion.inclusion_item.name}}</span>
                                      <span class="body-2 restrict-p-mb html-desc" v-html="inclusion.inclusion_item.description"></span>
                                    </li>
                                  </ul>
                                </div>
                              </template>

                                
                              <template>
                                <p class="pt-3 mb-2 body-2-2 text-15 font-bold">{{$t('hotel.rate-breakdown.title')}}</p>
                                  <div class="row slim-grid-row pb-2" v-for="(rate_breakdown, index) in data.dates">
                                    <div class="col-6">
                                      <p class="mb-0 body-2-2 font-regular text-truncate">{{formatDate(rate_breakdown.date)}} :</p>
                                      <p class="mb-1 body-2 text-12 text-green font-regular" v-if="rate_breakdown.promotion != null">{{parsingPromotionTypeText(rate_breakdown.promotion.promotion_type)}}</p>
                                    </div>
                                    <div class="col-6 text-right position-relative">
                                      <p class="mb-1 body-2 text-12 font-regular text-line-through" 
                                      v-if="(data.best_price.price+data.best_price.extra_guest_price) > rate_breakdown.final_price">
                                        {{formatCurrency(rate_breakdown.price+rate_breakdown.extra_guest_price)}}
                                      </p>
                                      <p class="mb-0 body-2-2 font-semibold underline text-15 d-table float-right hover-here">{{formatCurrency(rate_breakdown.final_price)}}
                                      </p>
                                      <template>
                                        <div class="hover-element bg-white border px-4 py-3 text-left position-absolute rounded-4 hover-rates popup-breakdown-rate" :class="{'breakdown-popup':data.room_type.image == ''}">
                                          <p class="mb-2 body-2-2 font-bold text-15">{{$t('hotel.rate-breakdown.rates-detail-price')}} : </p>
                                          <div class="row slim-grid-row">
                                            <div class="col-4 mb-1">
                                              <p class="mb-0 body-2-2 font-regular">{{$t('hotel.date.date')}} :</p>
                                            </div>
                                            <div class="col-8 mb-1 text-right">
                                              <p class="mb-0 body-2-2 font-regular">{{formatDate(rate_breakdown.date)}}</p>
                                            </div>
                                            <div class="col-12 mt-2">
                                              <div class="row slim-grid-row mb-2">
                                                <div class="col-6">
                                                  <p class="mb-0 body-3-3-2 font-regular">{{totalGuestIncluded(data)}}x {{$t('hotel.rate-breakdown.guest-included')}}</p>
                                                </div>
                                                <div class="col-6">
                                                  <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate_breakdown.price+rate_breakdown.promotion_price)}}</p>
                                                </div>
                                              </div>
                                              <!-- extra adult -->
                                              <div class="row slim-grid-row mb-2" v-if="rate_breakdown.extra_guest.adult.qty > 0">
                                                <div class="col-6">
                                                  <p class="mb-0 body-3-3-2 font-regular">{{rate_breakdown.extra_guest.adult.qty}}x {{$t('hotel.rate-breakdown.extra-adults')}}</p>
                                                </div>
                                                <div class="col-6">
                                                  <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate_breakdown.extra_guest.adult.total)}}</p>
                                                </div>
                                              </div>
                                              <!-- extra child -->
                                              <div class="row slim-grid-row mb-2" v-if="rate_breakdown.extra_guest.child.qty > 0">
                                                <div class="col-6">
                                                  <p class="mb-0 body-3-3-2 font-regular">{{rate_breakdown.extra_guest.child.qty}}x {{$t('hotel.rate-breakdown.extra-childs')}}</p>
                                                </div>
                                                <div class="col-6">
                                                  <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate_breakdown.extra_guest.child.total)}}</p>
                                                </div>
                                              </div>
                                              <!-- extra infant -->
                                              <div class="row slim-grid-row mb-2" v-if="rate_breakdown.extra_guest.infant.qty > 0">
                                                <div class="col-6">
                                                  <p class="mb-0 body-3-3-2 font-regular">{{rate_breakdown.extra_guest.infant.qty}}x {{$t('hotel.rate-breakdown.extra-infants')}}</p>
                                                </div>
                                                <div class="col-6">
                                                  <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate_breakdown.extra_guest.infant.total)}}</p>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-12">
                                              <div class="row slim-grid-row mt-2 border-top pt-3">
                                                <div class="col-6">
                                                  <p class="mb-0 body-2-2 font-bold">{{$t('hotel.total')}} :</p>
                                                </div>
                                                <div class="col-6 text-right">
                                                  <p class="mb-0 body-2-2 font-bold">{{formatCurrency(rate_breakdown.final_price)}}</p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </template>
                                    </div>
                                  </div>
                                <div class="row slim-grid-row mt-2 border-top pt-2">
                                  <div class="col-6">
                                    <p class="mb-0 body-2-2 font-bold text-16">{{$t('hotel.rate-breakdown.full-rates')}} : </p>
                                  </div>
                                  <div class="col-6 text-right">
                                    <p class="mb-0 body-2-2 text-18 font-bold">
                                      {{formatCurrency(totalRateBreakdown(data.dates))}}</p>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import moment from 'moment'
  import {mapGetters} from 'vuex'
  import Flickity from 'vue-flickity';
  import {customFormatDateTime} from '@/utils/index.js';
  import {formatCurrency,formatDate} from '@/utils/index.js'
  import Facilities from '@/components/hotel/facilities';

  export default{
    props: ['data'],
    components:{
      Flickity,
      Facilities
    },
    data(){
      return{
        flickityOptionsRoom:{
          initialIndex: 0,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: true,
          autoPlay: 2500,
          pauseAutoPlayOnHover: false
        },
        total_guest_included:'',
      }
    },
    methods:{
      ...mapGetters(['getMerchant','getBeFilter']),
      formatCurrency(data) {
        return formatCurrency(data)
      },
      formatTime(time){
        return moment(time, 'hh:mm:ss').format('hh:mm')
      },
      formatDate(date) {
        return customFormatDateTime(date, null, 'ddd, DD MMM YYYY')
      },
      displayToday(date) {
        if (moment().isSame(moment(date), 'day')) return this.$t('merchant.today')
        return customFormatDateTime(date, null, 'dddd')
      },
      onBack(type,data){
        this.$emit(type,data)
      },
      parsingPromotionTypeText(data){
        if(data == 'PROMO_CODE'){
          return 'Promo Code'
        }else if(data == 'REGION'){
          return 'Region'
        }else if(data == 'DEVICE'){
          return 'Device'
        }else if(data == 'MULTI_NIGHT'){
          return 'Multi Night'
        }else if(data == 'REMAINING_OCCUPANCY'){
          return 'Remaining Occupancy'
        }else if(data == 'EARLY_BIRD'){
          return 'Earlybird'
        }else if(data == 'LAST_MINUTE_DEAL'){
          return 'Last Minute Deal'
        }else if(data == 'SPECIAL_DEAL'){
          return 'Special Deal'
        }else{
          return data
        }
      },
      totalGuestIncluded(data){
        let total = this.getBeFilter().guest.adult+this.getBeFilter().guest.child+this.getBeFilter().guest.infant
        if(total  <= data.rate.guest_included){
          this.total_guest_included = total
        }else{
          this.total_guest_included = data.rate.guest_included
        }
        return this.total_guest_included
      },
      totalRateBreakdown(data) {
        let total_price_breakdown = 0
        for (let i = 0; i < data.length; i++) {
          total_price_breakdown += data[i].final_price
        }
        return total_price_breakdown
      },
    },
  }
</script>
<style scoped>
  .breakdown-popup{
    left: -73px!important;
    top: -180px!important;
  }
  .popup-breakdown-rate{
     width: 275px;
     z-index: 9;
     left: -112px;
     top: -170px;
     box-shadow: 0 10px 40px 0px #19171733
  }
  .bg-dark-transparent{
    background-color: rgb(35 35 35 / 88%)
  }
  .bg-blur-overlay{
    height: 90vh !important;
    filter:blur(10px);
    top:0px;
    left:0px;
    opacity:0.5;
    background-size:cover;
    background-position:center;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/desktop/roomRatesDetail.vue